webpackJsonp([196458740682427],{

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_Component) {
	  _inherits(AboutPage, _Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Datasert - About Us" }),
	      _react2.default.createElement(
	        "div",
	        { className: "content" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "About Datasert"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Started in 2010 as \"Real Force Explorer\", the Salesforce data management tool \"Realfire\" has grown to what it is today, with intent of providing seamless and efficient solution for Salesforce ecosystem."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Datasert Inc was founded to take Realfire to next level and also to bring other Salesforce products to solve real business problems."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Have something in mind or have question about company or our products? We'd love to hear from you. Please get in touch with",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "./contact" },
	            "us"
	          ),
	          "."
	        )
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-company-about-jsx-502919084f3e6e5f6f57.js